import { useState } from 'react'

import { type CoreCustomer } from '@flecto/types'

type UsePaginationReturn = {
  currentPage: number
  totalRecords: number
  searchTerm: string
  filteredCustomers: CoreCustomer[]
  pageSize: number
  handlePageChange: (newPage: number) => void
  setTotalRecords: (total: number) => void
  resetPage: () => void
  handleSearch: (term: string) => void
  setFilteredCustomers: (customers: CoreCustomer[]) => void
}

export function usePagination(pageSize: number): UsePaginationReturn {
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredCustomers, setFilteredCustomers] = useState<CoreCustomer[]>([])

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage)
  }

  const resetPage = () => {
    setCurrentPage(1)
  }

  const handleSearch = (term: string) => {
    resetPage()
    setSearchTerm(term)
  }

  return {
    currentPage,
    totalRecords,
    searchTerm,
    filteredCustomers,
    pageSize,
    handlePageChange,
    setTotalRecords,
    resetPage,
    handleSearch,
    setFilteredCustomers,
  }
}
